import { posthog } from 'posthog-js'

import type { PostHog } from 'posthog-js'

let posthogClient: PostHog | null = null

export function getPosthogClient(): PostHog | null {
  return posthogClient
}

/* eslint-disable camelcase */
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  posthogClient = posthog.init(runtimeConfig.public.POSTHOG_KEY, {
    api_host: runtimeConfig.public.POSTHOG_HOST,
    capture_pageview: false,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    loaded: posthog => {
      if (import.meta.env.MODE === 'development') {
        posthog.debug()
      }
    },
    person_profiles: 'identified_only',
  })

  const router = useRouter()
  router.afterEach(async (to: { fullPath: string }) => {
    await nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath,
      })
    })
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
/* eslint-enable camelcase */
